import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { CookieService } from 'ngx-cookie-service';
import { IAuthToken } from './auth-token.interface';
import { HttpClient } from '@angular/common/http';
import { catchError, throwError, BehaviorSubject, first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private _auth: IAuthToken;
  public inviteID$: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private _cookieService: CookieService,
    private _http: HttpClient,
  ) {}

  // Start of User Cookie functions
  public setCookie(): void {
    const authTransitionCookie = this._cookieService.get(environment.transitionCookie);
    let authCookie = this._cookieService.get(environment.authCookie);

    // console.debug('no auth cookie: ' + decodeURIComponent(authTransitionCookie));
    // console.debug('current auth cookie: ' + decodeURIComponent(laWebCoauthCookieokie));

    if (authTransitionCookie.length > 0) // Just logged in
      this.setToken(JSON.parse(decodeURIComponent(authTransitionCookie)));

    else if (authCookie.length > 0) // Reloaded the page (refresh or opened the browser)
      this.setToken(JSON.parse(decodeURIComponent(authCookie)));

    if (this._auth === null) // If nothing was set, no LAWEB nor LAAuth2LAWeb cookies found, kick back to LA-Auth
      this.killCookie()

  }

  public setToken(token: IAuthToken): void {
    //delete current auth token first
    this._deleteAuthCookie();

    this._cookieService.set(
      environment.authCookie, encodeURIComponent(JSON.stringify(token)),
      { path: '/', secure: true, sameSite: 'Strict' }
    );

    this._auth = { ...token };
  }

  public getToken(): IAuthToken {
    return this._auth;
  }

  public killCookie(): void {
    this._deleteAuthCookie();
    this.redirectToAuth();
  }

  public redirectToAuth(): void {
    this.inviteID$
      .pipe(first())
      .subscribe({
        next: (inviteID) => {
          var url = inviteID.length > 0 ? environment.authClient + 'SelfService/'+inviteID : environment.authClient + 'SelfService/';
          window.location.href = (window.location.href.includes('devselfservice.leadadvantagepro.com') || window.location.href.includes('localhost'))
          ? url + '?referrer=' + encodeURIComponent(window.location.href)
          : url;
        }
      });

  }

  public getAuthCookie(): string {
    return this._cookieService.get(environment.authCookie);
  }

  public requestRefresh(refreshToken: string) {
    let body = new FormData();
    body.append('grant_type', 'refresh_token');
    body.append('refresh_token', refreshToken);

    return this._http.post(environment.authClient + 'refresh_token', body).pipe(
      catchError((error) => {
        this.killCookie();
        return throwError(() => error);
      })
    );
  }

  private _deleteAuthCookie() {
    this._cookieService.delete(environment.transitionCookie, '/', '.leadadvantagepro.com'); // Always attempt to delete the auth transition cookie
    this._cookieService.delete(environment.authCookie, '/'); // delete environment specific cookie
  }

}
